import { useMemo } from 'react';

type DispatchSafeAutoRefreshStateInput = {
  hasBlockingDialogOpen: boolean;
  hasInFlightMutation: boolean;
  isAllDatesSelected: boolean;
  isBulkSelectionActive: boolean;
  isDragging: boolean;
  isFeatureFlagEnabled: boolean;
  preventUpsertOrder: boolean;
};

export default function useDispatchSafeAutoRefreshState({
  hasBlockingDialogOpen,
  hasInFlightMutation,
  isAllDatesSelected,
  isBulkSelectionActive,
  isDragging,
  isFeatureFlagEnabled,
  preventUpsertOrder,
}: DispatchSafeAutoRefreshStateInput) {
  // Applying is safe whenever no work-in-progress guard is active. Scroll position is
  // intentionally NOT a guard: applies preserve the viewport, so they are safe at any
  // scroll offset (TRE-15649).
  const isSafeToAutoApply = useMemo(() => {
    return (
      isFeatureFlagEnabled &&
      !isDragging &&
      !isBulkSelectionActive &&
      !hasBlockingDialogOpen &&
      !hasInFlightMutation &&
      !preventUpsertOrder &&
      !isAllDatesSelected
    );
  }, [
    hasBlockingDialogOpen,
    hasInFlightMutation,
    isAllDatesSelected,
    isBulkSelectionActive,
    isDragging,
    isFeatureFlagEnabled,
    preventUpsertOrder,
  ]);

  return { isSafeToAutoApply };
}
